import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { QuestionObj } from 'src/types/quiz';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

interface QuestionFormDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  question: QuestionObj;
}

const QuestionFormDialog: React.FC<QuestionFormDialogProps> = ({
  open,
  setOpen,
  question,
}) => {
  const [questionText, setQuestion] = useState<string>(question.question);
  const [answerText, setAnswer] = useState<string>(question.answer);

  const saveQuestion = () => {
    question.question = questionText;
    question.answer = answerText;
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Edit Question</DialogTitle>
          <DialogDescription>
            Enter the question and answer below. Click save when you're done.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-6 py-4">
          <div className="grid gap-2">
            <Label htmlFor="question">Question</Label>
            <Textarea
              id="question"
              value={questionText}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setQuestion(e.target.value)
              }
              className="min-h-[100px] resize-vertical"
              placeholder="Enter your question here..."
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="answer">Answer</Label>
            <Textarea
              id="answer"
              value={answerText}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setAnswer(e.target.value)
              }
              className="min-h-[100px] resize-vertical"
              placeholder="Enter your answer here..."
            />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={saveQuestion}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default observer(QuestionFormDialog);

export const openQuestionFormDialog = (
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
): void => {
  setOpen(true);
};
